import { Icon } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Home } from '../../../../../../../types/SMT';
import { formatAddress } from '../../../../../../common/src/utils/commonUtils';
import LabeledParamFallback from '../../../../../../common/src/components/label-param-fallback/LabelParamFallback';
import RiskObjectSelectRadio from '../RiskObjectSelectRadio';

interface Props {
  home: Home;
  isSelected: boolean;
  onSelect: () => void;
}

const HomeSelectRadio: React.FC<Props> = ({ home, isSelected, onSelect }) => {
  const { t } = useTranslation();
  const { address, holder_state, attachment, name } = home;

  return (
    <RiskObjectSelectRadio
      isSelected={isSelected}
      onSelect={onSelect}
      icon={<Icon name="GeneralRiskObjectsHome" />}
      title={name || ''}
    >
      <LabeledParamFallback label={t('ADDRESS')} gridColumn="span 2">
        {address && formatAddress(address)}
      </LabeledParamFallback>
      <LabeledParamFallback label={t('TYPE-INHABITANT')}>
        {holder_state && t(holder_state)}
      </LabeledParamFallback>
      <LabeledParamFallback label={t('BUILDING-TYPE')}>
        {attachment && t(attachment)}
      </LabeledParamFallback>
    </RiskObjectSelectRadio>
  );
};

export default HomeSelectRadio;
